import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import Main from './Main';
import HeroBusiness from './HeroBusiness';
import Hero3 from './hero3';

const BusinessArea = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <HeroBusiness />
            <Hero3 />
            <Main />
            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    );
};

export default BusinessArea;
